import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';
import { useSelector } from 'react-redux';

import { CoreLink } from '../../../../components';
import useClasses from '../../../../hooks/useClasses';
import { ImmutableMenuItem } from '../..';

import './style.scss';

interface Props {
  entity: ImmutableMenuItem;
}

const MenuTabbarItem: React.FC<Props> = ({ entity }) => {
  const href = entity.getIn(['link', 'url'], '');
  const title = entity.getIn(['link', 'title'], '');
  const className = entity.getIn(['link', 'options', 'attributes', 'class', 0], '');
  const pathname = useSelector((state: Immutable.Map<string, string>) => state.getIn(['router', 'location', 'pathname'], '') as string);
  const isActive = href === pathname;
  const isActiveTrail = pathname.startsWith(href) && !isActive;

  const { buildClass, joinClasses } = useClasses('MenuTabbarItem', { active: isActive || isActiveTrail });

  const iconClasses = c(
    'icon',
    className,
  );

  return (
    <li key={href}>
      <CoreLink to={href} className={joinClasses(buildClass(), 'menu-item')}>
        <div className={joinClasses(buildClass('icon'), iconClasses)} />
        {title}
      </CoreLink>
    </li>
  );
};

export default MenuTabbarItem;
